import * as components from './components';

export default [
    {
        path: '/emails',
        component: components.EmailsList,
        name: 'emailList',
        meta: { admin: true }
    }
];


// WEBPACK FOOTER //
// ./ClientApp/app/emails/routes.js